import {useState} from 'react';
import PageContainer from '../../../components/container/PageContainer';
import {
    TextField,
    Button,
    Stack,
    Box,
    useMediaQuery,
    useTheme
} from '@mui/material';
import Breadcrumb from '../../../layouts/full-layout/breadcrumb/Breadcrumb';
import LineNameLabel from '../../common/LineNameLabel';
import {useSelector} from 'react-redux';
import {useForm} from '../../../hooks/useForm';
import CreateContactModal from '../../../components/CreateContactModal';
import SearchIcon from '@mui/icons-material/Search';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import TableContactsBodyMobile from './TableContactsBodyMobile';

const BCrumb = [
    {to: '/', title: 'Inicio'},
    {title: 'Contactos'},
];

const TableHeadContactsMobile = () => {
    const {id_customer} = useSelector(state => state.agent);
    const [formValues, handleInputChange] = useForm({searcher: ''});
    const {searcher} = formValues;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [loading, setLoading] = useState(false);
    const [resetCounter, setResetCounter] = useState(0); // para reiniciar el scroll

    const handleSearcher = () => {
        setResetCounter(prev => prev + 1); // forzar reinicio de scroll
    };

    const handleClear = () => {
        handleInputChange({target: {name: 'searcher', value: ''}});
        setResetCounter(prev => prev + 1);
    };

    return (
        <PageContainer title='Contactos' description='Contactos'>
            <Breadcrumb title={<LineNameLabel/>} items={BCrumb}/>
            <Stack
                spacing={2}
                direction={isMobile ? 'column' : 'row'}
                justifyContent="space-between"
                alignItems={isMobile ? 'stretch' : 'center'}
                sx={{p: 2}}
            >
                <Box display='flex' flexDirection={isMobile ? 'column' : 'row'} gap={1}>
                    <TextField
                        fullWidth
                        variant='outlined'
                        name="searcher"
                        value={searcher}
                        onChange={handleInputChange}
                        placeholder="Buscar por nombre o número"
                    />
                    <Button fullWidth={isMobile} variant="contained" onClick={handleSearcher}
                            startIcon={<SearchIcon/>}
                            disabled={loading}>
                        {loading ? 'Cargando...' : 'Buscar'}
                    </Button>
                    <Button fullWidth={isMobile} variant="contained" onClick={handleClear}
                            startIcon={<RestoreFromTrashIcon/>}
                            disabled={loading}>
                        Limpiar
                    </Button>
                </Box>

                <Box display='flex' justifyContent={isMobile ? 'flex-start' : 'flex-end'}>
                    <CreateContactModal/>
                </Box>
            </Stack>
            <TableContactsBodyMobile
                id_customer={id_customer}
                searcher={searcher}
                resetCounter={resetCounter}
                setLoading={setLoading}
            />
        </PageContainer>
    );
};

export default TableHeadContactsMobile;
